import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { closeModalGlobal } from '../redux/features/modalSlice';

const ModalInfo = () => {
  const dispatch = useDispatch();
  const { modalInfo } = useSelector(({ modal }) => modal);

  const handleClose = () => {
    dispatch(
      closeModalGlobal({
        isOpen: false,
        isData: {},
      }),
    );
  };

  return (
    <Modal
      size="md"
      centered
      show={modalInfo.isOpen}
      onHide={() => handleClose()}
      keyboard={false}
      backdrop="static"
    >
      <div className="modal-header">
        <h5 className="modal-title ">User Details</h5>
      </div>
      <div className="modal-body user-detail-modal">
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label className="labelMove">Name:</label>
              <small>
                {!modalInfo.isData.firstname
                  ? '---'
                  : ` ${modalInfo.isData.firstname || ''} ${
                      modalInfo.isData.lastname || ''
                    }
                       `}
              </small>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label className="labelMove">Email:</label>
              <small>{modalInfo.isData?.email || '---'}</small>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label className="labelMove">Phone:</label>
              <small>{modalInfo.isData?.phone || '---'}</small>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label className="labelMove">Country:</label>
              <small>{modalInfo.isData?.country || '---'}</small>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label className="labelMove">Status:</label>
              <small>{modalInfo.isData?.status || '---'}</small>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label className="labelMove">Currency:</label>
              <small>{modalInfo.isData?.currency || '---'}</small>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label className="labelMove">Credit:</label>
              <small>{modalInfo.isData?.credit || '---'}</small>
            </div>
          </div>

          <div className="col-md-12 text-right">
            <button
              type="button"
              onClick={() => handleClose()}
              className="btn btn-default"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalInfo;
